var BaseViews = require('../../../common/base');
var AvailableAtLocationView = BaseViews.ItemView.extend({
    className: 'fmcy-available-at-location',
    template: require('./available-at-locations/available-at-location.html'),
    tagName: 'li',
    events: {
        'click a': function (e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (!this.options.loadHomePageURLOnClick) {
                // If we're not loading the home page then we're loading the
                // menu with location set so scroll to the top for the user.
                this.options.appChannel.request('scroll:to:page:top');
            }
        }
    },
    initialize: function (options) {
        this.options = _.defaults(
            options || {},
            {
                loadHomePageURLOnClick: false
            }
        );
    },
    serializeData: function () {
        return {
            options: this.options,
            location: this.model.toJSON()
        };
    }
});


require('./available-at-locations/available-at-locations.scss');
var AvailableAtLocationsView = Backbone.Marionette.CompositeView.extend({
    className: 'fmcy-available-at-locations',
    template: require('./available-at-locations/available-at-locations.html'),
    childView: AvailableAtLocationView,
    childViewContainer: '.fmcy-locations-container',
    childViewOptions: function (model, index) {
        return {
            loadHomePageURLOnClick: this.options.loadHomePageURLOnLocationLabelClick,
            appChannel: this.options.appChannel
        };
    },
    initialize: function (options) {
        this.options = _.defaults(
            options || {},
            {
                preLocationsListText: 'available at ',
                postLocationsListText: '',
                loadHomePageURLOnLocationLabelClick: true,
                align: 'center'
            }
        );
    },
    onRender: function () {
      if (this.options.align == 'left') {
        this.$el.addClass('fmcy-available-at-locations-align-left');
      }
    },
    serializeData: function () {
        return {
            options: this.options
        };
    }
});

module.exports = AvailableAtLocationsView;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/available-at-locations.js
 **/